import { render, staticRenderFns } from "./BrandingKit.vue?vue&type=template&id=609bbc0c&scoped=true&"
import script from "./BrandingKit.vue?vue&type=script&lang=ts&"
export * from "./BrandingKit.vue?vue&type=script&lang=ts&"
import style0 from "./BrandingKit.vue?vue&type=style&index=0&id=609bbc0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609bbc0c",
  null
  
)

export default component.exports